/**
 * Pub/sub mínimo pra mutations de grant avisarem o AuthContext sem depender do contexto React
 * (hooks de admin são testados sem AuthProvider; notify sem listener é no-op).
 * Cobre o caso "editei meu próprio acesso" na hora; pros DEMAIS users vale o polling de 5min
 * do AuthContext — push via socket fica pro backlog (exige mudança de back).
 */
type Listener = () => void

const listeners = new Set<Listener>()

export function onGrantsChanged(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function notifyGrantsChanged(): void {
  listeners.forEach((listener) => listener())
}
